import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Button } from "~/components/common/button";

import IconArrow from "./icon-arrow.svg?url";

const arrowButtonCSS = css`
  position: absolute;
  inset-block-start: 50%;
  z-index: 1;

  display: none;
  justify-content: center;
  align-items: center;

  inline-size: 44px;
  block-size: 44px;

  border-radius: 50%;

  &::before {
    position: absolute;
    inset-block-start: 12px;
    content: url(${IconArrow});
  }

  &:disabled {
    opacity: 0.5;
  }
`;

export const ArrowLeft = styled(Button)`
  inset-inline-start: 0;
  ${arrowButtonCSS}

  &::before {
    inset-block-start: 10px;

    transform: rotate(180deg);
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;

export const ArrowRight = styled(Button)`
  inset-inline-end: 0;
  ${arrowButtonCSS}

  ${props => props.theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;
